import { Landmark } from 'lucide-react';
import { bankLogoByCode } from '@/domains/mobile-web/utils/bankLogo';

interface BankLogoProps {
  /** DOKU bank code */
  code: string;
  name?: string;
}

/** The bank's logo, or a generic bank icon for a bank without one. */
const BankLogo = ({ code, name }: BankLogoProps) => {
  const logo = bankLogoByCode(code);
  return (
    <figure className="w-[40px] h-[40px] shrink-0 rounded-[4px] border border-blue-cs-200 bg-white overflow-hidden flex items-center justify-center">
      {logo ? (
        <img src={logo} alt={name} className="w-full h-full object-contain" />
      ) : (
        <Landmark size={20} className="text-text-blue-100" aria-label={name} />
      )}
    </figure>
  );
};

export default BankLogo;
